import React from "react";
import NavBar from "../../components/navbar/NavBar";
import Footer from "../../components/footer/Footer";
import "./chinaStyle.css";
import { Link } from "react-router-dom";
import { ChinaCity } from "../../data/chinaCity";

const China = () => {
  // 将城市数据分为热门城市和省份
  const popularCities = ChinaCity.filter(city => city.isCity === true);

  const provinces = ChinaCity.filter(province => province.isCity === false);

  return (
    <div className="china-page">
      <NavBar />
      <h1 className="china-title">你想去哪个城市跑步？</h1>

      {/* 热门城市部分 */}
      <h2 className="china-subtitle">热门城市</h2>
      <div className="china-container">
        {popularCities.map((city) => (
          <Link to={`/china/${city.id}`} key={city.id}>
            <div className="city-card">
              <img src={city.image} alt={city.name} className="china-image" />

            </div>
          </Link>
        ))}
      </div>

      {/* 省份部分 */}
      <h2 className="china-subtitle">中国的省份</h2>
      <div className="china-container">
        {provinces.map((province) => (
          <Link to={`/china/${province.id}`} key={province.id}>
            <div className="city-card">
              <img src={province.image} alt={province.name} className="china-image" />

            </div>
          </Link>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default China;
